























import { Vue, Component, Prop, Model } from 'vue-property-decorator';

import { TabState } from '@/views/top/product/basic/ProductList.vue';
export interface SummaryItem<T> {
  name: string;
  count: number;
  value: T;
}

// 본래 쿼리까지 심어주던 아이였으나 클릭이벤트만 emit 해주는 선으로 강등함
@Component
export default class SummaryTab extends Vue {
  @Model('select') private readonly value: TabState;
  @Prop({ required: true })
  private readonly tabData: SummaryItem<TabState>[];
  @Prop({ required: false, default: '' })
  private readonly unitString: string;

  private selectedTabState: TabState = '';

  mounted() {
    const { selectedClassification } = this.$route.query;
    const tabStates: TabState[] = ['ALL', 'ON_SALE', 'SOLD_OUT', 'STOCK_UNDER_TEN', 'ON_SALE_SUMMARY'];
    const matched = tabStates.some(state => state === selectedClassification);
    if (selectedClassification && matched) {
      // TODO : 매우 나쁜 해결책. 상품 리스트 페이지의 컴포넌트들이 $nextTick 을 남발하여 이 동작을 최후순위로 하기 위함
      setTimeout(() => {
        this.onClickTab(selectedClassification as TabState);
      }, 0);
    }
  }

  private onClickTab(value: TabState): void {
    this.selectedTabState = value;
    this.$emit('select', this.selectedTabState);
  }
}
